import { render, staticRenderFns } from "./relatorios-hub.vue?vue&type=template&id=3cd0ece3&scoped=true&"
import script from "./relatorios-hub.vue?vue&type=script&lang=js&"
export * from "./relatorios-hub.vue?vue&type=script&lang=js&"
import style0 from "./relatorios-hub.vue?vue&type=style&index=0&id=3cd0ece3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd0ece3",
  null
  
)

export default component.exports